export function useGetOptInManagerV2(): {
  isOptInManagerV2?: boolean;
  error?: string;
} {
  return { isOptInManagerV2: false };
}
